var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c("TagAnnotateForm", {
        attrs: {
          "recent-tags": _vm.recentTags,
          "show-loader": _vm.showLoader,
          "existing-selected-tag": _vm.cachedData
        },
        on: {
          annotateCallSubmit: _vm.annotateCallSubmit,
          cacheFormData: _vm.cacheFormData,
          closeForm: function($event) {
            return _vm.$emit("closeForm")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }